import React, { useState, useEffect } from 'react';
import WatchlistChart from '../../components/Watchlist/WatchlistChart';
import ExpandedCountryRow from 'components/Watchlist/ExpandedCountryRow';
import ExpandedSourceCountryRow from './ExpandedSourceCountryRow';
import CircularProgress from '@mui/material/CircularProgress';

interface IWatchlistUpperProps {
  countryData: any;
  handleScroll: any;
  selectedIndex: any;
}

const WatchlistUpper: React.FC<IWatchlistUpperProps> = ({
  selectedIndex,
  countryData,
  handleScroll,
}) => {
  const [ total, setTotal ] = useState(0);

  useEffect(() => {
    const countryTotals: number[] = [];
    if (selectedIndex === 'Watchlist') {
      countryData?.data?.countryAgg?.buckets?.map((country: any) => {
        countryTotals.push(country.doc_count);
      });
      const countryTotal = countryTotals.reduce(
        (accum: number, cur: number) => {
          return accum + cur;
        },
        0,
      );
      setTotal(countryTotal);
    }
    if (selectedIndex === 'Country Risk') {
      countryData?.data?.countryAgg?.buckets?.map((country: any) => {
        countryTotals.push(country.doc_count);
      });
      const countryTotal = countryTotals.reduce(
        (accum: number, cur: number) => {
          return accum + cur;
        },
        0,
      );
      setTotal(countryTotal);
    }
  }, [ countryData, selectedIndex ]);

  return (
    <>
      <div className='denied-sources'>
        <div className='ds-header'>
          <div className='ds-header-text'>Data Sources</div>
          <div className='ds-header-text-records' onClick={handleScroll}>
            View Detailed Records
          </div>
        </div>
        <div className='ds-table-top'>
          <div className='ds-table-space'></div>
          <div className='ds-table-col'>
            <div className='ds-table-col-header'>
              <div className='ds-col-title'>Source</div>
            </div>
          </div>
          <div className='ds-table-col-end'>
            <div className='ds-table-col-header'>
              <div className='ds-col-title'>Records</div>
            </div>
          </div>
        </div>
        <div className='ds-table'>
          {selectedIndex === 'Watchlist' &&
            countryData.data.countryAgg.buckets.map(
              (country: any, index: number) => (
                <ExpandedCountryRow key={index} data={country} />
              ),
            )}
          {selectedIndex === 'Country Risk' &&
            countryData.data.countryAgg.buckets.map(
              (country: any, index: number) => (
                <ExpandedSourceCountryRow key={index} data={country} />
              ),
            )}
        </div>
        <div className='ds-footer'>
          <div className='ds-foot-text'>Total</div>
          <div className='ds-total'>{total.toLocaleString()}</div>
        </div>
      </div>
      <div className='country-breakdown'>
        <div className='cb-header'>
          <div className='cb-header-text'>Data Breakdown by Source</div>
        </div>
        {countryData.isLoading ? (
          <div>
            <CircularProgress style={{ color: '#0E8BFF' }} />
          </div>
        ) : (
          <WatchlistChart
            selectedIndex={selectedIndex}
            countryData={countryData}
          />
        )}
      </div>
    </>
  );
};

export default WatchlistUpper;
